import React from 'react'
import styled from 'styled-components'
import { PolygonGrey, PolygonRed } from '../../components/Styled'
import { getContainerBgColor, getCardBgColor, getTextColor } from '../../utils'
import { Slide } from '../../components'

const Section = props => {
  const { content, page } = props

  return (
    <Slide>
      <Container page={page} getBgColor={getContainerBgColor}>
        <ImageWrapper>
          <ImageCard>
            <Image src={content.image} page={page} alt={content.title} />
            <PolygonGrey display-if={content.polygon === 'grey'} />
            <PolygonRed display-if={content.polygon === 'red'} />
          </ImageCard>
        </ImageWrapper>
        <ContentWrapper>
          <ContentCard page={page} getBgColor={getCardBgColor}>
            <ContentBox page={page} getTextColor={getTextColor}>
              <h1 display-if={content.title}>{content.title}</h1>
              <h2 display-if={content.subTitle}>{content.subTitle}</h2>
              <p display-if={content.paragraphFirst}>
                {content.paragraphFirst}
              </p>
              <h2 display-if={content.subTitleSecond}>
                {content.subTitleSecond}
              </h2>
              <p display-if={content.paragraphSecond}>
                {content.paragraphSecond}
              </p>
            </ContentBox>
          </ContentCard>
        </ContentWrapper>
      </Container>
    </Slide>
  )
}

const Container = styled.div(props => ({
  display: 'flex',
  flexFlow: 'row wrap',
  height: '100%',
  position: 'relative',
  overflow: 'hidden',
  backgroundColor: props.getBgColor(props.page, props.theme),
  '@media (max-width: 960px)': {
    flexFlow: 'column wrap',
  },
}))

const ImageWrapper = styled.div(props => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  flexGrow: 2,
  zIndex: 1,
  '@media (max-width: 960px)': {
    flexBasis: '25%',
  },
}))

const ImageCard = styled.div(props => ({
  position: 'relative',
  width: '100%',
  height: '100%',
  backgroundColor: props.theme.colorLinkWater,
}))

const Image = styled.img(props => ({
  position: 'absolute',
  maxWidth: '320px',
  width: '90%',
  margin:
    (props.alt === 'Ability' && props.page === '/team/software-development') ||
    (props.alt === 'Mission' && props.page === '/team/banking')
      ? '0'
      : '0 auto',
  left: 0,
  right: props.alt === 'Mission' && props.page === '/team/banking' ? '' : 0,
  top: props.page === '/team/it-operations' ? '60%' : '50%',
  transform: 'translateY(-50%)',
  zIndex: 2,
  '@media (max-width: 1280px)': {
    width: '55%',
  },
  '@media (max-width: 960px)': {
    width:
      props.alt === 'Ability' && props.page === '/team/banking'
        ? '25%'
        : props.alt === 'Mission' && props.page === '/team/banking'
        ? '45%'
        : props.alt === 'Ability' && props.page === '/team/software-development'
        ? '55%'
        : '35%',
  },
  '@media (max-width: 600px)': {
    top:
      props.alt === 'Mission' && props.page === '/team/banking'
        ? 'unset'
        : '50%',
    transform:
      props.alt === 'Mission' && props.page === '/team/banking'
        ? 'unset'
        : 'translateY(-50%)',
    bottom: '-15px',
    width: '20%',
  },
}))

const ContentWrapper = styled.div(props => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  flexGrow: 1,
  zIndex: 2,
  '@media (max-width: 960px)': {
    flexBasis: '75%',
  },
}))

const ContentCard = styled.div(props => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  height: '100%',
  backgroundColor: props.getBgColor(props.page, props.theme),
  boxShadow: '-1px 0 15px 0 rgba(0,0,0,0.27)',
}))

const ContentBox = styled.div(props => ({
  width: '640px',
  padding: '2rem',
  'h1, h2, p': {
    color: props.getTextColor(props.page, props.theme),
  },
  h1: {
    marginBottom: '3rem',
  },
  h2: {
    marginBottom: '1rem',
  },
  p: {
    marginBottom: '1rem',
  },
  'h2:last-of-type': {
    marginTop: '2rem',
  },
  '@media (max-width: 1280px)': {
    h1: {
      fontSize: '3rem',
      marginBottom: '1rem',
    },
    h2: {
      fontSize: '2rem',
      marginBottom: '.7rem',
    },
    'h2:last-of-type': {
      marginTop: '1rem',
    },
  },
  '@media (max-width: 960px)': {
    width: '100%',
    padding: '0 2.7rem',
    h1: {
      fontSize: '2rem',
      marginBottom: '1rem',
    },
    h2: {
      fontSize: '1.25rem',
      marginBottom: '.7rem',
    },
    'h2:last-of-type': {
      marginTop: '.7rem',
    },
  },
}))

export default Section
